import React, { useEffect, useState } from "react";
import FilterForm from "./FilterForm";
import ActiveCell from "./../Companies/CompanyTable/ActiveCell";
import CustomTable from "../../ui/CustomTable";
import { useMember } from "./provider";
import { useNavigate } from "react-router-dom";
import TabsList from "../../ui/TabsList";
import { FilterField } from "./Fields";
import { createYupSchema } from "../../utilities/yupSchemaCreator";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuth } from "../../services/auth";
import ExpireDateStyle from "./Render/ExpireDateStyle";
import { Box, Button, useTheme } from "@mui/material";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";

const yupSchema = FilterField.reduce(createYupSchema, {});
const formSchema = Yup.object().shape(yupSchema);
const List = () => {
  const { role, adminOn } = useAuth();
  const navigate = useNavigate();
 let theme = useTheme();
  const [error, setError] = useState();

  const form = useForm({
    resolver: yupResolver(formSchema),
  });
  const cols = [
    {
      label: "Member Name",
      name: "memberName",
      headTextLeft: true,
      textLeft: true,
    },
    {
      label: "Plan Type",
      name: "planName",
    },
    {
      label: "Mobile",
      name: "mobile",
    },
    {
      label: "Start Date",
      name: "startDate",
    },
    { label: "Expire Date", name: "expireDate", customRender: ExpireDateStyle },
    { label: "Balance", name: "balance" },
    { label: "Status", name: "isActive", customRender: ActiveCell },
  ];

  const {
    state: { list, page, count, perPage, length, companyIdAtt },
    dispatch,
    fetchList,
    uploadExcelFile,
  } = useMember();
  const tabs = [{ title: "Members", num: length }];
  const [selectedCols, setSelectedCols] = useState("Members");
   let planId = form.watch("pid");
   let companyID = form.watch("id");
  const handleDetail = (id) => {
    navigate(`MemberDetails/${id}`);
  };

  const changePageSize = (size) => {
    dispatch({ type: "set_per_page", payload: size });
  };

  const handleAddNewMember = () => {
    if (companyIdAtt) {
      navigate("add");
    } else {
      setError("Select company at first");
    }
  };

  useEffect(() => {
    if (form.getValues("id") && role === "Admin")
      fetchList(
        form.getValues("id"),
        form.getValues("pid"),
        form.getValues(),
        page,
        perPage
      );
  }, [page, perPage, form, role]);

  useEffect(() => {
    if (role === "Company" && form.getValues("pid"))
      fetchList(
        adminOn?.id,
        form.getValues("pid"),
        form.getValues(),
        page,
        perPage
      );
  }, [page, perPage, form, adminOn, role]);
 const handleImport = async (event) => {
   const file = event.target.files?.[0];

   if (!file) return;

   const isExcelFile = /\.(xlsx|xls)$/i.test(file.name);

   if (!isExcelFile) {
     setError("Please select an Excel file (.xlsx or .xls)");
     event.target.value = "";
     return;
   }
   if (file && isExcelFile) {
     try {
       await uploadExcelFile(file, companyIdAtt, planId, companyID);
     } catch (error) {
       setError(error.errors.message);
     }
   }
 };
  return (
    <>
      <FilterForm form={form} error={error} setError={setError} />
      <Box
        sx={{ display: "flex", justifyContent: "space-between", width: "80%" }}
      >
        <TabsList
          tabs={tabs}
          setSelectedCols={setSelectedCols}
          selectedCols={selectedCols}
        />

        {planId && companyID ? (
          <Button
            component="label"
            sx={{
              border: `1px solid ${theme.color.Screamingreen}`,
              color: theme.color.Screamingreen,
              mt: "5px",
              textTransform: "capitalize",
              "&:hover": {
                background: theme.color.gray50,
              },
              cursor: "pointer",
            }}
          >
            Import Excel
            <CloudUploadOutlinedIcon sx={{ mx: 1 }} />
            <input
              hidden
              type="file"
              accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
              onChange={handleImport}
            />
          </Button>
        ):null}
      </Box>
      <CustomTable
        empty={list?.length === 0 ? true : false}
        cols={cols}
        data={list || []}
        filters={{
          pagination: true,
          page: perPage,
          changePageSize: changePageSize,
          add: role !== "SubCompany" && handleAddNewMember,
        }}
        moreOptions={{
          detail: handleDetail,
        }}
        page={page}
        showButton={true}
        rowsPerPage={10}
        dispatch={dispatch}
        count={count}
      />
    </>
  );
};

export default React.memo(List);
